var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11396_138569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8929 13.7074H20.8438V11.5521C20.8438 11.2163 20.5724 10.9449 20.2366 10.9449H14.26L12.0345 8.81616C12.0062 8.78965 11.9689 8.77475 11.9301 8.77441H7.10714C6.77132 8.77441 6.5 9.04573 6.5 9.38156V20.6137C6.5 20.9495 6.77132 21.2208 7.10714 21.2208H20.3504C20.5971 21.2208 20.821 21.071 20.914 20.8414L23.4564 14.5423C23.4848 14.4702 23.5 14.3924 23.5 14.3146C23.5 13.9788 23.2287 13.7074 22.8929 13.7074ZM7.86607 10.1405H11.4425L13.7117 12.311H19.4777V13.7074H9.80134C9.55469 13.7074 9.3308 13.8573 9.23783 14.0869L7.86607 17.4869V10.1405ZM19.9198 19.8548H8.30246L10.2624 14.9976H21.8816L19.9198 19.8548Z",
    fill: "#414141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11396_138569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(6.5 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.a384860213ca0c0864840027e5dd5a29.svg";
export { ForwardRef as ReactComponent };